<template>
  <section>
    <div class="mx-2 mt-3 mb-2 rounded-lg">
      <figure class="relative flex flex-col justify-center">
        <img
          class="mb-3 object-cover w-full h-28 sm:h-64 rounded-lg"
          :src="Location.img"
          :alt="Location.imgAlt"
        />
        <figcaption
          class="absolute bottom-0 px-3 pb-1 mx-3 self-center text-center whitespace-normal text-2xl sm:text-4xl border border-white text-white bg-dark-500/50  backdrop-blur-xs rounded-lg"
        >
          <span class="capitalize">{{ I18nNO.importCalendar }}</span>
        </figcaption>
      </figure>
    </div>
    <article class="prose mx-2 mt-3 px-3 pt-3 pb-12 bg-white rounded-lg">
      <h2 id="hvem-vi-er">Legge til kalender</h2>
      <p>
        Kongsvinger Bedehus henter data fra to Google-kalendere;
        <NuxtLink
          to="https://calendar.google.com/calendar/ical/ed45da04295479bd70cef4d5839621d36af616752b230035f195dea0c565a7fa%40group.calendar.google.com/public/basic.ics"
        >
          <SvgCalendar
            class="w-5 h-5 inline align-text-bottom"
          />Bede-kalenderen
        </NuxtLink>
        for voksne og familier, og
        <NuxtLink
          to="https://calendar.google.com/calendar/ical/12aee95a916fda1f23ca59d540a37939b7d72af6c725c3cb49ce3c99875b72a7%40group.calendar.google.com/public/basic.ics"
        >
          <SvgCalendar class="w-5 h-5 inline align-text-bottom" />Bede
          Ung-kalenderen
        </NuxtLink>
        for barn og ungdom.
      </p>
      <h4>iPhone/iPad/Mac</h4>
      For å legge til kalenderen på iPhone/iPad/Mac:
      <ol>
        <li>
          Klikk på lenken for
          <ul class="!mt-0">
            <li>
              <NuxtLink
                to="webcal://calendar.google.com/calendar/ical/ed45da04295479bd70cef4d5839621d36af616752b230035f195dea0c565a7fa%40group.calendar.google.com/public/basic.ics"
                ><SvgCalendar
                  class="w-5 h-5 inline align-text-bottom"
                />Bede</NuxtLink
              >
            </li>
            <li>
              <NuxtLink
                to="webcal://calendar.google.com/calendar/ical/12aee95a916fda1f23ca59d540a37939b7d72af6c725c3cb49ce3c99875b72a7%40group.calendar.google.com/public/basic.ics"
              >
                <SvgCalendar class="w-5 h-5 inline align-text-bottom" />Bede Ung
              </NuxtLink>
            </li>
          </ul>
        </li>
        <li>Velg "Åpne i Kalender"</li>
        <li>Klikk "Abonnér"</li>
      </ol>
      <h4>Android/Windows/Linux</h4>
      <p>
        For å legge til kalenderen på Android, eller i en kalender som ikke
        automatisk åpnes av å klikke på lenkene ovenfor, må du i stedet kopiere
        lenken, åpne kalender-appen og legge til der. Hvis du bruker Google
        Calendar på telefonen, må du åpne
        <NuxtLink to="https://calendar.google.com"
          >calendar.google.com</NuxtLink
        >
        i en nettleser, logge inn med samme konto som er tilknyttet kalenderen
        på telefonen, og knytte kalenderen til Google-kontoen din slik det
        beskrives i
        <NuxtLink
          to="https://www.androidauthority.com/add-new-calendar-google-calendar-3141782/"
          >denne guiden</NuxtLink
        >.
      </p>
      <p>
        Lenken for Bede er:
        <span class="block bg-green-100 p-1 rounded-md font-mono break-all">
          https://calendar.google.com/calendar/ical/ed45da04295479bd70cef4d5839621d36af616752b230035f195dea0c565a7fa%40group.calendar.google.com/public/basic.ics
        </span>
        Lenken for Bede Ung er:
        <span class="block bg-green-100 p-1 rounded-md font-mono break-all">
          https://calendar.google.com/calendar/ical/12aee95a916fda1f23ca59d540a37939b7d72af6c725c3cb49ce3c99875b72a7%40group.calendar.google.com/public/basic.ics
        </span>
      </p>
    </article>
  </section>
</template>

<script setup lang="ts">
import Location from "@/data/Location";
import PlainI18nNO from "@/data/I18nNO";
const I18nNO = reactive(PlainI18nNO);

useHead({
  title: I18nNO.importCalendarLink,
});

onMounted(() => window.scrollTo(0, 0));
</script>
